import { render, staticRenderFns } from "./MyChangeMeans.vue?vue&type=template&id=21f8912b&"
import script from "./MyChangeMeans.vue?vue&type=script&lang=js&"
export * from "./MyChangeMeans.vue?vue&type=script&lang=js&"
import style0 from "./MyChangeMeans.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports